// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__182S3","Label":"Input_Label__2UF3_","InputElement":"Input_InputElement__1LlFC","UpperCase":"Input_UpperCase__P6FYy","Invalid":"Input_Invalid__3mq7G"};